<template>
    <v-col cols="12" lg="12" md="12" sm="12">
        <v-select v-model="form.phone.phone_quantity" density="compact" variant="outlined" label="Approximately how many phones do you need?" :items="[{title:'---',value:null},'1 To 3','4 To 49','50+']"/>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
